<div class="dataMismatchPopup pos-relative" id="bucket-items-transfer-dialog-cnt-root">
  <button
    (click)="onCloseClick()"
    class="closeBtn pull-right"
    mat-button
    color="accent"
    id="bucket-items-transfer-dialog-btn-close"
  >
    <span class="icon-ic-close popup_close"></span>
  </button>
  <h5 class="p-20 m-0 bottomBorderStyle align font-xl p-t-m-i" id="bucket-items-transfer-dialog-lbl-title">
    One or more package(s) cannot be transferred
  </h5>

  <div class="form-label m-b-s align">
    The following package(s) cannot be transferred because of a mismatch in study completion date or checksums.
  </div>
  <div class="dataMismatchTableContainer" id="bucket-items-transfer-dialog-cnt-table">
    <table class="w-100" mat-table id="bucket-items-transfer-dialog-tbl-grid" [dataSource]="dataSource">

      <ng-container matColumnDef="{{ this.sourceBucket }}">
        <th mat-header-cell *matHeaderCellDef>{{ this.sourceBucket }}</th>
        <td mat-cell *matCellDef="let item">{{ item.SourceBucketDate }}</td>
      </ng-container>

      <ng-container matColumnDef="{{ this.destinationBucket }}">
        <th mat-header-cell *matHeaderCellDef>{{ this.destinationBucket }}</th>
        <td mat-cell *matCellDef="let item">
          {{ item.DestinationBucketDate }}
        </td>
      </ng-container>
      <ng-container matColumnDef="Checksum">
        <th mat-header-cell *matHeaderCellDef>Checksum</th>
        <td mat-cell *matCellDef="let item">
          {{ item.ChecksumStatus ==='VerifiedAndCorrupted' || item.IsChecksumMismatch? "mismatch" : null }}
        </td>
      </ng-container>
      <ng-container matColumnDef="Package folder">
        <th mat-header-cell *matHeaderCellDef class=align-items>
          Package folder
        </th>
        <td mat-cell *matCellDef="let item">{{ item.FolderName }}</td>
      </ng-container>
      <ng-container matColumnDef="header-row-first-group">
        <th
          class="mat-header-cell align-items"
          mat-header-cell
          *matHeaderCellDef
        ></th>
      </ng-container>
      <!-- header row second group-->
      <ng-container class="align" matColumnDef="header-row-second-group">
        <th
          class="mat-header-cell align-items"
          mat-header-cell
          *matHeaderCellDef
          [attr.colspan]="2"
        >
          Study Completion Date
        </th>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="['header-row-first-group', 'header-row-second-group']"
      ></tr>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
  <div class="okayButtonContainer" id="bucket-items-transfer-dialog-cnt-actions">
    <button
      mat-raised-button
      color="primary"
      type="submit"
      class="p-20 m-20 okbutton"
      id="bucket-items-transfer-dialog-btn-ok"
      (click)="onCloseClick()"
    >
      OK
    </button>
  </div>
</div>
